import { useTheme } from 'styled-components';

export const FinancialDataIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4 2C3.44772 2 3 2.44772 3 3V17C3 17.5523 3.44772 18 4 18H16C16.5523 18 17 17.5523 17 17V7L12 2H4Z"
        stroke={theme.iceBlue}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M12 2V7H17" stroke={theme.iceBlue} strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M7 11H13" stroke={theme.iceBlue} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7 14H11" stroke={theme.iceBlue} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M10 8L10 9" stroke={theme.iceBlue} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};
